<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
                <v-row>
                    <v-col
                            v-for="(bar, i) in bars"
                            :key="i"
                            cols="12"
                            sm="12"
                            md="12"
                    >
                        <v-card  color="grey lighten-4" flat >
                            <v-toolbar style="height: 90px" :color="bar.class" :dark="bar.dark">
                               
                               <v-row style="margin-top: 2.5%;">

                                    <v-col md="1" sm="1" xl="1">
                                       <img style="width: 200px;" src="../../public/mineimages/avatar.png" alt="" class="img-thumbnail rounded-circle">
                                    </v-col>

                                    <v-col md="8" sm="8" xl="8">
                                       <p style="margin-top: 3%;font-size: 16px;color:#fff;font-weight: 600" >{{user.name}}</p>
                                    </v-col>

                                    <v-col md="2" sm="2" xl="2">
                                        <v-chip style="margin-top: 9%" v-if="user.relation!=null" color="green" dark>{{ user.relation.nom }}</v-chip>
                                        <v-chip style="margin-right: 15px;margin-top: 9%" v-else  color="green" dark>Administrateur</v-chip>

                                    </v-col>

                                    <v-col md="1" sm="1" xl="1">
                                         <v-btn @click.prevent="logout" style="margin-top: 10%" icon>
                                            <v-icon>mdi-power</v-icon>
                                        </v-btn>
                                    </v-col>



                               </v-row>

                            </v-toolbar>
                        </v-card>
                    </v-col>
                </v-row>
            <v-card>
            <v-form  style="margin-top: 3%">
                <v-container>
                    <v-alert  v-if="errors"  dense outlined :type="(errors.update_error)?'error':'success'">{{(errors.message)}}</v-alert>
                    <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>

                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="user.name" label="Nom & Prénom" single-line solo></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field :rules="[rules.required]" v-model="user.email" label="Email" single-line solo></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="user.phone" label="Télephone" single-line solo></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col >
                            <v-btn @click="updateInformations" class="float-right" color="primary" >Mettre à jour</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-form v-model="passFormValid">
                <v-container>
                    <v-row class="pl-5">
                        <h4>Mettre à jour votre mot de passe
                        </h4>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-text-field
                                    :append-icon="showOldPass ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min]"
                                    :type="showOldPass ? 'text' : 'password'"
                                    @click:append="showOldPass=!showOldPass"
                                    label="Ancien mot de passe"
                                    single-line solo v-model="old_password"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field
                                    v-model="password"
                                    :append-icon="showNewPass ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min]"
                                    :type="showNewPass ? 'text' : 'password'"
                                    @click:append="showNewPass=!showNewPass"
                                    label="Nouveau mot de passe" single-line solo></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field
                                    :append-icon="showConfirmPass ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min,rules.match]"
                                    :type="showConfirmPass ? 'text' : 'password'"
                                    @click:append="showConfirmPass=!showConfirmPass"
                                    label="Confirmer mot de passe" single-line solo></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col >
                            <v-btn @click="updatePassword" class="float-right" color="primary" >Mettre à jour</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
            </v-card>

        </div>
        <!-- End Page-content -->
    </div>
</template>

<script>

    export default {
        name: "Profil",
        components: {},
        data() {
            return {
                submitting:false,
                showOldPass:false,
                showNewPass:false,
                showConfirmPass:false,
                passFormValid:false,
                infoFormValid:false,
                countryHasChanged:false,
                rules: {
                    required: value => !!value ||  '',
                    min: v => v!==undefined && v.length >= 8 || '',
                    match: v => v == this.password || '',
                    email: v => (v.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) ||  'Email invalid',
                },
                image:null,
                imageUrl:'images/faces/face2.jpg',
                password:'',
                old_password:'',                valid: true,
                user: JSON.parse(localStorage.getItem("user")),
                bars: [
                    { class: 'primary', dark: true },
                ],
                lazy: false,
                errors:undefined,
                search: '',
                tabs: null,
                dialog: '',
                id: undefined,
                snackbar: false,
                items: [
                    { state: 'Demande refusée', abbr: 'Demande refusée' },
                    { state: 'Retrait éffectué', abbr: 'Retrait éffectué' },
                    { state: 'Demande confirmée, en attente de paiement', abbr: 'Demande confirmée, en attente de paiement' },
                    { state: 'En attente', abbr: 'En attente' },
                    { state: 'Annuler', abbr: 'Annuler  ' },
                ],
                textSnack: '',
                headers: [
                    {text: 'Pharmacie', value: 'pharmacie_slug'},

                    {
                        text: 'Montant',
                        align: 'start',
                        sortable: true,
                        value: 'montant',
                    },
                    {text: 'Numéro de retrait', value: 'phone_receiver'},
                    {text: 'Balance', value: 'balance_now'},
                    {text: 'Demandé par:', value: 'pharmacie_user_slug'},
                    {text: 'Commentaire', value: 'comment'},
                    {text: 'Etat', value: 'state_ask'},
                    {text: 'Message', value: 'comment_ask_admin'},
                    {text: 'Date de demande', value: 'ask_time'},


                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                libelRules: [
                    v => !!v || 'Commentaire requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],


            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle forme" : "Commentaire"
            }

        }

        ,

        mounted() {
            window.scrollTo(0,0);
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            updateInformations(){
                let data = new FormData();
                data.append("name",this.user.name);
                data.append("phone",this.user.phone);
                data.append("email",this.user.email);
                data.append("id",this.user._id);
                if (this.user.email===undefined || this.user.email.trim().length===0){
                    return;
                }
                this.submitting=true;
                let responseObj = {};
                this.$store.dispatch('users/setUpdateUser',data).then((response)=>{
                    this.submitting=false;
                    responseObj.update_error = response.error;
                    responseObj.message = response.message;
                    this.errors = responseObj;

                    if (!response.error){
                        //location.reload()
                    }

                })
            },
            updatePassword(){
                if (!this.passFormValid)
                    return;
                let responseObj = {};
                let data = new FormData();
                data.append('new_password',this.password);
                data.append('old_password_hash',this.user.password);
                data.append('old_password',this.old_password);
                this.submitting=true;
                this.$store.dispatch('users/updatePassword',data).then((response)=>{
                    console.log(response);
                    this.submitting=false;
                    responseObj.update_error = response.error;
                    responseObj.message = response.message;
                    this.errors = responseObj;
                })
            },
             logout() {

                let data = new FormData();
                data.append('email', this.email);
                data.append('password', this.password);
                this.$store.dispatch("auth/logout", data).then(response => {
                    window.console.log(response);
                    this.submitting = false;
                    if (response.error) {
                        this.state = 'error';
                        this.errors.login = response.message;
                    } else {
                        window.location = window.origin
                    }
                });
            },


            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor(){
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>